import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Iconify from '../../../../components/Iconify';
import { useMutation } from 'react-fetching-library';
import MailIcon from '@mui/icons-material/Mail';
import { ConfirmDialog } from '../../../../components/ConfirmDialog';
import { sendEmployeeMail } from '../../../../services/request';
import toast from 'react-hot-toast';


export const SendCredentialsMesage = ({ rowData }) => {
  const { mutate } = useMutation(sendEmployeeMail);
  const [open, setOpen] = React.useState(false);


  const handleSendCredentialsMesage = async () => {
    const notificationType = rowData.group_display === 'kadra zarządzająca' ? 'SLAM' : 'SLAP';
    const { loading, error } = await mutate(rowData.employee.id, { 'notification_type': notificationType });
    if (!loading && !error) {
      toast.success('Wysłano pomyślnie');

    } else if (error) {
      toast.error('Nie udało się wysłać wiadomości');
    }
  };

  return (
    <>
      <Tooltip title="Wyślij maila z danymi">
        <IconButton
          color="primary"
          onClick={() => setOpen(true)}

        >
          <MailIcon color="secondary"/>
        </IconButton>
      </Tooltip>
      <ConfirmDialog
        title="WYsłać wiadomość do użytkownika?"
        open={open}
        setOpen={setOpen}
        onConfirm={handleSendCredentialsMesage}
      >
        Czy na pewno chcesz wysłać wiadomość z danymi do logowania?
      </ConfirmDialog>
    </>
  );
};
export default SendCredentialsMesage;
